import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWeatherBora = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 31.65,
	height: 31.811,
	viewBox: "0 0 31.65 31.811",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group_6628",
		"data-name": "Group 6628",
		transform: "translate(-2922 -1248)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9150",
				"data-name": "Path 9150",
				d: "M15.757,0a4.22,4.22,0,0,0-4.111,3.274A4.2,4.2,0,0,0,6.381,6.942a4.221,4.221,0,1,0-2.065,7.9,4.013,4.013,0,0,0,.625-.051,4.216,4.216,0,0,0,5.617,2.38,7.234,7.234,0,0,0,5.013,1.8c2.774,0,5.115-1.269,5.871-3.011a4.214,4.214,0,0,0,6.431-1.784c2.15-.6,3.682-2.145,3.682-3.959,0-2.331-2.527-4.222-5.645-4.222a7.521,7.521,0,0,0-1.094.08A4.69,4.69,0,0,0,20.55,3.542a5.331,5.331,0,0,0-.624.041A4.221,4.221,0,0,0,15.757,0Z",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9151",
				"data-name": "Path 9151",
				d: "M28.8,17.856v1.773l-1.536-.887a.375.375,0,0,0-.375.65l1.535.886-1.535.887a.375.375,0,0,0,.375.649l1.536-.887V22.7a.375.375,0,1,0,.749,0V20.927l1.536.887a.375.375,0,0,0,.374-.649l-1.535-.887,1.535-.886a.375.375,0,0,0-.374-.65l-1.536.887V17.856a.374.374,0,1,0-.749,0",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9152",
				"data-name": "Path 9152",
				d: "M2.1,17.352v1.773L.562,18.238a.375.375,0,0,0-.375.649l1.536.886L.187,20.66a.375.375,0,0,0,.375.65L2.1,20.423V22.2a.375.375,0,1,0,.75,0V20.423l1.535.887a.375.375,0,1,0,.374-.65l-1.535-.887,1.535-.886a.375.375,0,1,0-.374-.649l-1.535.887V17.352a.375.375,0,1,0-.75,0",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9153",
				"data-name": "Path 9153",
				d: "M16.315,26.592v1.773l-1.535-.887a.375.375,0,0,0-.376.649l1.536.887L14.4,29.9a.375.375,0,0,0,.376.65l1.535-.886v1.773a.375.375,0,0,0,.75,0V29.664l1.535.886a.375.375,0,0,0,.375-.65l-1.536-.886,1.536-.887a.375.375,0,0,0-.375-.649l-1.535.887V26.592a.375.375,0,0,0-.75,0",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9154",
				"data-name": "Path 9154",
				d: "M5.569,28.864A.863.863,0,1,0,6.431,28a.863.863,0,0,0-.862.862",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9155",
				"data-name": "Path 9155",
				d: "M20.135,21.731A.862.862,0,1,0,21,20.869a.862.862,0,0,0-.862.862",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9156",
				"data-name": "Path 9156",
				d: "M9.311,21.709a.863.863,0,1,0,.863-.863.862.862,0,0,0-.863.863",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_9157",
				"data-name": "Path 9157",
				d: "M28.316,28.864A.862.862,0,1,0,29.178,28a.863.863,0,0,0-.862.862",
				transform: "translate(2922 1248)",
				fill: "#67a4fe"
			})
		]
	})
});
export { SvgWeatherBora as ReactComponent };
